import intl from 'react-intl-universal';

const codeMessages = {
  'entry.move_contains_locked_children': 'card.move.locked_attachments.error',
};

export default (code, defaultMessage) =>
  codeMessages[code] ? intl.get(codeMessages[code]) || defaultMessage : defaultMessage;
